import { createAction } from 'redux-act';

const PREFIX = 'BILLING_INSIGHTS';

export const emailReportRequest = createAction<string>(`${PREFIX}/EMAIL_REPORT.REQUEST`);
export const emailReportSuccess = createAction(`${PREFIX}/EMAIL_REPORT.SUCCESS`);
export const emailReportFailure = createAction(`${PREFIX}/EMAIL_REPORT.FAIL`);
